// extracted by mini-css-extract-plugin
export default {"logoColumn":"TimelineLegInfo-module__logoColumn___oZf6U","carrierLogoImg":"TimelineLegInfo-module__carrierLogoImg___bJ2iI","textColumn":"TimelineLegInfo-module__textColumn___hBEfI"};